import AddIcon from "../../../assets/icons/admin/add.svg?react";
import ArrowLeftIcon from "../../../assets/icons/arrowleft.svg?react";
import ArrowRightIcon from "../../../assets/icons/arrowright.svg?react";
import BinIcon from "../../../assets/icons/admin/bin.svg?react";
import BookIcon from "../../../assets/icons/admin/book.svg?react";
import CloseIcon from "../../../assets/icons/admin/close.svg?react";
import CopiedIcon from "../../../assets/icons/admin/copied.svg?react";
import CopyIcon from "../../../assets/icons/admin/copy.svg?react";
import DraggerIcon from "../../../assets/icons/admin/dragger.svg?react";
import EditIcon from "../../../assets/icons/admin/edit.svg?react";
import MenuIcon from "../../../assets/icons/admin/menu.svg?react";
import MoreIcon from "../../../assets/icons/admin/more.svg?react";
import PendingIcon from "../../../assets/icons/admin/pending.svg?react";
import PhotoLibraryIcon from "../../../assets/icons/admin/photo_library.svg?react";
import ProfileIcon from "../../../assets/icons/admin/profile.svg?react";
import ShareIcon from "../../../assets/icons/admin/share.svg?react";
import TwoPagerIcon from "../../../assets/icons/admin/two_pager.svg?react";
import UsersIcon from "../../../assets/icons/admin/users.svg?react";
import VideoLibraryIcon from "../../../assets/icons/admin/video_library.svg?react";
import ViewIcon from "../../../assets/icons/admin/view.svg?react";
import OpenIcon from "../../../assets/icons/admin/open.svg?react";
import CheckmarkIcon from "../../../assets/icons/admin/checkmark.svg?react";
import LibraryIcon from "../../../assets/icons/toolbar-icons/Library.svg?react";
import PersonIcon from "../../../assets/icons/person.svg?react";
import ChecklistIcon from "../../../assets/icons/checklist.svg?react";
import QuestionmarkIcon from "../../../assets/icons/questionmark.svg?react";
import ResetPassword from "../../../assets/icons/resetpassword.svg?react";
import XMark from "../../../assets/icons/x-mark.svg?react";
import Teachers from "../../../assets/icons/toolbar-icons/Teachers.svg?react";
import Showroom from "../../../assets/icons/toolbar-icons/Showroom.svg?react";
import ArrowUpload from "../../../assets/icons/toolbar-icons/Upload.svg?react";
import XMarkWithoutBorder from "../../../assets/icons/xmarkwithoutborder.svg?react";
import Chevron from "../../../assets/icons/chevron.svg?react";
import Landscape from "../../../assets/icons/landscape.svg?react";
import Pencil from "../../../assets/icons/pencil.svg?react";

export const icons = {
  open: OpenIcon,
  close: CloseIcon,
  copy: CopyIcon,
  copied: CopiedIcon,
  dragger: DraggerIcon,
  more: MoreIcon,
  edit: EditIcon, //will might be deprecated, still used in groupNameEditButton, but design is old
  bin: BinIcon,
  add: AddIcon,
  users: UsersIcon,
  view: ViewIcon,
  arrowleft: ArrowLeftIcon,
  arrowright: ArrowRightIcon,
  menu: MenuIcon,
  two_pager: TwoPagerIcon,
  photo_library: PhotoLibraryIcon,
  book: BookIcon,
  video_library: VideoLibraryIcon,
  profile: ProfileIcon,
  share: ShareIcon,
  pending: PendingIcon,
  checkmark: CheckmarkIcon,
  library: LibraryIcon,
  person: PersonIcon,
  checklist: ChecklistIcon,
  questionmark: QuestionmarkIcon,
  arrowupload: ArrowUpload,
  teachers: Teachers,
  showroom: Showroom,
  resetpassword: ResetPassword,
  xmark: XMark,
  xmarkwithoutborder: XMarkWithoutBorder,
  chevron: Chevron,
  landscape: Landscape,
  pencil: Pencil,
};

function Icon({ name, size = "24px", className = undefined }) {
  const Svg = icons[name];

  if (!Svg) {
    return null;
  }

  return <Svg className={className} width={size} height={size} aria-hidden />;
}

export default Icon;
